import { useEffect, useState } from 'react';
import GroupForm from './GroupForm';
import AdnMessageError from '../common/adnMessage/AdnMessageError';
import { getQuestionByGroupId } from '../../api/QuizAPI/QuestionAPI';
import { Form } from 'antd';
import { addGroup, deleteGroup, getGroupById, updateGroup, updateGroupOrder } from '../../api/QuizAPI/GroupAPI';
import AdnMessageSuccess from '../common/adnMessage/AdnMessageSuccess';
import ManageQuestionPage from './ManageQuestionPage';
import moment from "moment";
import { AnswerType, dateFormat } from '../common/GeneralConfigurations';



const ManageGroupPage = ({
    index,
    isSubGroup = false,
    parentGroupId,
    quizId,
    group,
    subGroups = [],
    setShowAddGroupButton,
    setGroupButtons,
    setShowPublishButton,
    onGetGroupsByQuizId,
    groups,
    isFirstSubgroup,
    isLastSubgroup,
    quiz,
    setAnswerBySwitch
}) => {

    const [groupForm] = Form.useForm();
    const [formSubGroup] = Form.useForm();
    const [quizGroupQuestions, setQuizGroupQuestions] = useState([]);
    const [groupQuiz, setGroupQuiz] = useState({ ...group });
    const [questionsByGroupId, setQuestionsByGroupId] = useState([]);
    const [showGroupButtons, setShowGroupButtons] = useState(false);
    const [quizSubGroup, setQuizSubGroup] = useState([]);
    const [editGroup, setEditGroup] = useState(true);

    const groupNameValidation = [
        { required: true, message: "Group name is required" },
    ];

    useEffect(() => {
        if (group) {
            onGetQuestionsByGroupId(group.id);
            setEditGroup(false);
        }
    }, [quiz]);

    useEffect(() => {
        setSubGroupsForGroups();
    }, [groups]);

    useEffect(() => {
        handleCheckAllQuestions();
    }, [questionsByGroupId, quiz.status]);

    const handleSaveGroup = async (values) => {
        setEditGroup(false);
        groupQuiz.id
            ? handleUpdateGroup(values)
            : handleAddGroup(values);
    }

    // Save db
    const handleAddGroup = async (values) => {
        await addGroup({
            quizId: quizId,
            name: values.name,
            note: values.note,
            minAnswers: values.minAnswers,
            maxAnswers: values.maxAnswers,
            order: index,
            parentGroupId: parentGroupId
        })
            .then((res) => {
                if (res.status === 200) {
                    if (setGroupButtons !== undefined) {
                        setGroupButtons(true);
                    }
                    setShowAddGroupButton(true);
                    onGetGroupsByQuizId(quizId);
                    AdnMessageSuccess("Group added with success.");
                }
                else {
                    const errors = res.data.errors;

                    errors.forEach((error) => {
                        const errorMessage = error.message;
                        AdnMessageError(errorMessage);
                    });
                }
            }).catch(() => {
                AdnMessageError("Could not add group.");
            });
    }

    const handleUpdateGroup = async (values) => {
        await updateGroup({
            id: values.id,
            quizId: quizId,
            name: values.name,
            note: values.note,
            minAnswers: values.minAnswers,
            maxAnswers: values.maxAnswers,
            order: index
        })
            .then((res) => {
                if (res.status === 200) {
                    AdnMessageSuccess("Group updated with success.");
                } else {
                    const errors = res.data.errors;

                    errors.forEach((error) => {
                        const errorMessage = error.message;
                        AdnMessageError(errorMessage);
                    });
                }
            }).catch(() => {
                AdnMessageError("Could not update group.");
            });
    }

    const handleMoveUp = async (event) => {
        await updateGroupOrder({
            id: event.id,
            sortDirection: "-",
        })
            .then((res) => {
                if (res.status === 200) {
                    onGetGroupsByQuizId(event.quizId);
                    AdnMessageSuccess("Order of group changed with success.");
                } else {
                    const errors = res.data.errors;

                    errors.forEach((error) => {
                        const errorMessage = error.message;
                        AdnMessageError(errorMessage);
                    });
                }
            }).catch(() => {
                AdnMessageError("Could not change the order of the group.");
            })
    }

    const handleMoveDown = async (event) => {
        await updateGroupOrder({
            id: event.id,
            sortDirection: "+",
        })
            .then((res) => {
                if (res.status === 200) {
                    onGetGroupsByQuizId(event.quizId);
                    AdnMessageSuccess("Order of group changed with success.");
                } else {
                    const errors = res.data.errors;

                    errors.forEach((error) => {
                        const errorMessage = error.message;
                        AdnMessageError(errorMessage);
                    });
                }
            }).catch(() => {
                AdnMessageError("Could not change the order of the group.");
            })
    }

    const handleDeleteGroup = async (event) => {
        await deleteGroup(event.id)
            .then((res) => {
                if (res.status === 200) {
                    onGetGroupsByQuizId(event.quizId, true);
                    AdnMessageSuccess("Group deleted with success.");
                } else {
                    const errors = res.data.errors;

                    errors.forEach((error) => {
                        const errorMessage = error.message;
                        AdnMessageError(errorMessage);
                    });
                }
            }).catch(() => {
                AdnMessageError("Could not delete group.");
            })
    }

    const handleGroupName = (event) => {
        setGroupQuiz({ ...groupQuiz, description: event.target.value });
    }

    const handleGroupNote = (event) => {
        setGroupQuiz({ ...groupQuiz, note: event.target.value });
    }

    const handleGroupMaxAnswer = (event) => {
        setGroupQuiz({ ...groupQuiz, maxAnswers: event.target.value });
    }

    const handleGroupMinAnswer = (event) => {
        setGroupQuiz({ ...groupQuiz, minAnswers: event.target.value });
    }

    const onGetQuestionsByGroupId = async (groupId, isDelete = false) => {
        await getQuestionByGroupId(groupId)
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        setAnswerBySwitch(true);

                        const transformedData = res.data.map(question => {
                            if (question.answerTypeId === AnswerType.Data) {
                                if (question.minValue && question.maxValue) {
                                    const transformedMinValue = moment(question.minValue, dateFormat);
                                    const transformedMaxValue = moment(question.maxValue, dateFormat);
                                    return { ...question, minValue: transformedMinValue, maxValue: transformedMaxValue };
                                } else {
                                    return { ...question, minValue: "", maxValue: "" };
                                }
                            }
                            return question;
                        });
                        setQuestionsByGroupId([...transformedData]);
                    } else {
                        if (isDelete) {
                            setAnswerBySwitch(false);
                        }
                        setQuestionsByGroupId([]);
                    }
                    setShowGroupButtons(true);
                } else {
                    const errors = res.data.errors;

                    errors.forEach((error) => {
                        const errorMessage = error.message;
                        AdnMessageError(errorMessage);
                    });
                }
            }).catch(() => {
                AdnMessageError("Error retrieving questions.");
            });
    };

    // display subgroups
    const setSubGroupsForGroups = () => {
        const isInputFocused = document.activeElement.tagName === 'INPUT';

        if (isInputFocused) {
            return;
        }

        if (subGroups.length > 0) {
            const subGroupsLocal = subGroups.map((element, index) => (
                <ManageGroupPage
                    key={element.id}
                    isSubGroup={true}
                    parentGroupId={parentGroupId}
                    group={element}
                    groupForm={formSubGroup}
                    quizId={element.quizId}
                    index={element.order}
                    subGroups={[]}
                    setShowAddGroupButton={setShowAddGroupButton}
                    setGroupButtons={setShowGroupButtons}
                    setShowPublishButton={setShowPublishButton}
                    onGetGroupsByQuizId={onGetGroupsByQuizId}
                    groups={groups}
                    isFirstSubgroup={index === 0}
                    isLastSubgroup={subGroups.length - 1 === index}
                    quiz={quiz}
                    setAnswerBySwitch={setAnswerBySwitch}
                />
            ));
            setQuizSubGroup(subGroupsLocal);
        } else {
            setQuizSubGroup([]);
        }
    };

    const handleCheckAllQuestions = () => {
        if (questionsByGroupId.length === 0) {
            setQuizGroupQuestions([]);
            return;
        }

        const newQuizGroupQuestions = questionsByGroupId.map((question, index) => (
            <ManageQuestionPage
                key={question.id}
                index={index + 1}
                isSubGroup={isSubGroup}
                question={question}
                groupId={groupQuiz.id}
                setShowPublishButton={setShowPublishButton}
                onGetQuestionsByGroupId={onGetQuestionsByGroupId}
                questionsByGroupId={questionsByGroupId}
                quiz={quiz}
                setAnswerBySwitch={setAnswerBySwitch}
            />
        ));

        setQuizGroupQuestions(newQuizGroupQuestions);
    };

    const handleAddQuestion = () => {
        const index = quizGroupQuestions.length + 1;

        let newQuestion;
        if (isSubGroup) {
            newQuestion = (<ManageQuestionPage
                index={index}
                groupId={groupQuiz.id}
                setShowAddGroupButton={setShowAddGroupButton}
                setShowGroupButtons={setGroupButtons}
                setShowPublishButton={setShowPublishButton}
                onGetQuestionsByGroupId={onGetQuestionsByGroupId}
                questionsByGroupId={questionsByGroupId}
                quiz={quiz}
                setAnswerBySwitch={setAnswerBySwitch}
            />)
        } else {
            newQuestion = (<ManageQuestionPage
                index={index}
                groupId={groupQuiz.id}
                setShowAddGroupButton={setShowAddGroupButton}
                setShowGroupButtons={setShowGroupButtons}
                setShowPublishButton={setShowPublishButton}
                onGetQuestionsByGroupId={onGetQuestionsByGroupId}
                questionsByGroupId={questionsByGroupId}
                quiz={quiz}
                setAnswerBySwitch={setAnswerBySwitch}
            />)
        }
        setQuizGroupQuestions([...quizGroupQuestions, newQuestion]);
        setShowAddGroupButton(false);
        if (isSubGroup) {
            setGroupButtons(false);
        } else {
            setShowGroupButtons(false);
        }
    }

    // new empty subgroup
    const handleAddSubgroup = (parentGroupId) => {
        let subgroup = (
            <ManageGroupPage
                isSubGroup={true}
                parentGroupId={parentGroupId}
                groupForm={formSubGroup}
                quizId={quizId}
                index={index + 0.01}
                setShowAddGroupButton={setShowAddGroupButton}
                setGroupButtons={setShowGroupButtons}
                setShowPublishButton={setShowPublishButton}
                onGetGroupsByQuizId={onGetGroupsByQuizId}
                groups={groups}
                quiz={quiz}
                setAnswerBySwitch={setAnswerBySwitch}
            />
        );
        setQuizSubGroup([...quizSubGroup, subgroup]);
        setShowGroupButtons(false);
        setShowAddGroupButton(false);
    }

    const handleCancelGroup = async (event) => {
        if (groupQuiz.id) {
            await getGroupById(event.id)
                .then((res) => {
                    if (res.status === 200) {
                        const { name, note, minAnswers, maxAnswers } = res.data;

                        groupForm.setFieldsValue({
                            name,
                            note,
                            minAnswers,
                            maxAnswers
                        });
                        AdnMessageSuccess("Group changes canceled with success.");

                        setEditGroup(false);
                    } else {
                        const errors = res.data.errors;

                        errors.forEach((error) => {
                            const errorMessage = error.message;
                            AdnMessageError(errorMessage);
                        });
                    }
                }).catch(() => {
                    AdnMessageError("Could not cancel the group.");
                })
        } else {
            onGetGroupsByQuizId(quizId);
        }
        setShowGroupButtons(true);
        setShowAddGroupButton(true);
        if (setGroupButtons !== undefined) {
            setGroupButtons(true);
        }
    }

    return (
        <>
            <GroupForm
                index={index}
                isSubGroup={isSubGroup}
                quizId={quizId}
                groupQuiz={groupQuiz}
                groupNameValidation={groupNameValidation}
                handleMoveUp={handleMoveUp}
                handleMoveDown={handleMoveDown}
                handleDeleteGroup={handleDeleteGroup}
                handleCancelGroup={handleCancelGroup}
                handleGroupName={handleGroupName}
                handleGroupNote={handleGroupNote}
                handleGroupMaxAnswer={handleGroupMaxAnswer}
                handleGroupMinAnswer={handleGroupMinAnswer}
                questionsByGroupId={questionsByGroupId}
                groupForm={groupForm}
                formSubGroup={formSubGroup}
                handleSaveGroup={handleSaveGroup}
                showGroupButtons={showGroupButtons}
                setShowAddGroupButton={setShowAddGroupButton}
                setShowGroupButtons={setShowGroupButtons}
                setGroupButtons={setGroupButtons}
                quizGroupQuestions={quizGroupQuestions}
                setShowPublishButton={setShowPublishButton}
                setQuizSubGroup={setQuizSubGroup}
                quizSubGroup={quizSubGroup}
                handleAddQuestion={handleAddQuestion}
                handleAddSubgroup={handleAddSubgroup}
                groups={groups}
                subGroups={subGroups}
                isFirstSubgroup={isFirstSubgroup}
                isLastSubgroup={isLastSubgroup}
                quiz={quiz}
                setEditGroup={setEditGroup}
                editGroup={editGroup}
            />
        </>
    );
};

export default ManageGroupPage;